import type { Territory } from '@amzn/vinyl-amzn'

const EU_TERRITORIES: ReadonlySet<Territory> = new Set<Territory>([
    'GB',
    'DE',
    'FR',
    'IT',
    'ES',
    'IN',
    'AE',
    'SA',
    'EG',
])

export function isMarketplaceEU(territory: string): boolean {
    return EU_TERRITORIES.has(territory as Territory)
}
